import React from 'react';

import { FlexRow } from 'ui-components/components/flex';

import { ProductDetailsModalFooter } from '../../footer';
import { ProductDetailsDrawerContent } from '../../drawer-content/drawer-content';
import { ProductDetailsDrawerSidebar } from '../drawer-sidebar/drawer-sidebar';
import { ProductDetailsDrawerHeader } from '../product-details-drawer-header/product-details-drawer-header';
import style from './drawer-shell.module.css';

export const ProductDetailsDrawerShell = () => (
  <>
    <ProductDetailsDrawerHeader />
    <FlexRow className={style.body}>
      <ProductDetailsDrawerSidebar />
      <div className={style.content}>
        <ProductDetailsDrawerContent />
      </div>
    </FlexRow>
    <div className={style.footer}>
      <ProductDetailsModalFooter />
    </div>
  </>
);
